/**
 * Created by Ning Jiang on 2/21/2020.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {
    IPickAndClickConfig,
    PickAndClickController
} from "@nolimitcity/slot-game/bin/core/pickandclick/PickAndClickController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {DWBackground} from "../../background/DWBackground";
import {DeadwoodSoundConfig} from "../../DeadwoodSoundConfig";
import {DeadwoodGameMode} from "../../gamemode/DeadwoodGameMode";
import {DeadwoodMultiplierController} from "../../multiplier/DeadwoodMultiplierController";
import {FireParticles} from "../../particles/FireParticles";
import {DeadwoodParsedInitData} from "../../server/data/DeadwoodParsedInitData";
import {IDeadwoodParsedServerData} from "../../server/data/IDeadwoodParsedServerData";
import {DeadwoodPickNClickIntroView} from "./DeadwoodPickNClickIntroView";

export class DeadwoodPickNClickIntroController extends PickAndClickController {

    private _gameView:DeadwoodPickNClickIntroView;

    private _playerFSSelection:number;

    constructor(config:IPickAndClickConfig) {
        super("PickNClick", config);
        this._gameView = <DeadwoodPickNClickIntroView>this._view;
    }

    protected parseFeatureGameData(data:IDeadwoodParsedServerData):void {
        this._playerFSSelection = data.playerFSSelection;
    }

    protected calculateIsRestoreTriggered(data:DeadwoodParsedInitData):boolean {
        return data.nextMode === DeadwoodGameMode.FREESPIN_HUNTERS || data.nextMode === DeadwoodGameMode.FREESPIN_GUNSLINGER;
    }

    protected calculateIsTriggered(data:IDeadwoodParsedServerData):boolean {
        return data.nextMode === DeadwoodGameMode.FREESPIN_PICK;
    }

    protected parseButtonConfigs(data:IDeadwoodParsedServerData):any[] {
        return [1, 2]; // pick index: 1-FREESPIN_GUNSLINGER, 2-FREESPIN_HUNTERS.
    }

    protected onButtonClick(selectedIndex:number, autoClicked:boolean = false):void {
        // StarStruckGameModuleConfig.soundPlayer.playEffect(StarStruckSoundConfig.instance.BONUS_STAR_PICK);
        this._playerFSSelection = selectedIndex;
        // when autoClicked, send 3 and 4 instead of 1 and 2.
        autoClicked ? selectedIndex += 2 : selectedIndex;
        super.onButtonClick(selectedIndex, autoClicked);
        // DragonTribeGameModuleConfig.soundPlayer.playEffect(DragonTribeSoundConfig.FS_SELECT);
    }

    protected playReplay():void {
        // autoSelected
        if(this._replayPlayerSelectionIndex > 2) {
            this._view.clickButton(this._replayPlayerSelectionIndex - 2 - 1, true);
        } else {
            this._view.clickButton(this._replayPlayerSelectionIndex - 1);
        }
    }

    protected doTransitions():void {
        EventHandler.dispatchEvent(new GameEvent(DWBackground.BURN_FRAME, true, 0.1));
        EventHandler.dispatchEvent(new GameEvent(DWBackground.DIM_STAGE, 0.6, 0.1));
        EventHandler.dispatchEvent(new GameEvent(DWBackground.FS_FIRE, true, false));
        EventHandler.dispatchEvent(new GameEvent(FireParticles.START));
    }

    protected show(isRestoreSelected:boolean):void {
        super.show(isRestoreSelected);
        SlotGame.sound.playAmbience(DeadwoodSoundConfig.instance.FS_INTRO_AMBIANCE);
    }

    protected close():void {
        if(this._playerFSSelection === 1) {
            // to show X1 or restore in Gunslinger mode.
            EventHandler.dispatchEvent(new GameEvent(DeadwoodMultiplierController.SHOW_END_MULTIPLIER, true));
        }

        // This will turn off Autoplay if in restricted jurisdiction
        if(SlotGame.autoPlay.turnOffAutoplayOnBonus) {
            SlotGame.autoPlay.turnOffAutoplayOnBonus();
        }
        super.close();
    }
}